import { useTranslation } from 'react-i18next';

import { getDateTime } from 'services/types';
import { Link } from './grid.params.styled';

/**
 * get link for record
 * @param {*} data
 * @returns
 */
const getLink = (data) => {
  const { params, method } = data;
  let field = '';
  const { t } = useTranslation();

  switch (method) {
    case 'clients.change_status':
      return (
        <Link to={'/card/client?id=' + params.id} title={t('buttons.Перейти в карточку клиента')}>
          <img src="/images/icon-go.png" alt="" />
        </Link>
      );
    case 'clients.update':
      return (
        <Link to={'/card/client?id=' + params.id} title={t('buttons.Перейти в карточку клиента')}>
          <img src="/images/icon-go.png" alt="" />
        </Link>
      );
    case 'rfid.add':
      return '-';
    case 'rfid.change_status':
      // props.dispatch(reset('rfidFilter'))
      // props.dispatch(change('rfidFilter', 'rfid', params.id))
      // return <Link to={'/payments/rfid'}><img src='/images/icon-go.png' alt=''/></Link>
      return '-';
    case 'stays.set_handicapped':
    case 'stays.set_exemption':
    case 'stays.change_suspicious':
      field = params['stay_id'] ? 'stay_id' : params['id'] ? 'id' : '';

      return (
        <Link
          to={'/card/stay?id=' + params[field]}
          target="_blank"
          rel="noopener noreferrer"
          title={t('buttons.Перейти в карточку парковки')}
          onClick={(ev) => {
            ev.stopPropagation();
          }}
        >
          <img src="/images/icon-go.png" alt="" />
        </Link>
      );
    case 'tariff.change_status':
      return (
        <Link to={'/options/tariff?id=' + params.id} title={t('buttons.Перейти в тарифы')}>
          <img src="/images/icon-go.png" alt="" />
        </Link>
      );
    case 'tariff.update':
      return (
        <Link to={'/options/tariff?id=' + params.id} title={t('buttons.Перейти в тарифы')}>
          <img src="/images/icon-go.png" alt="" />
        </Link>
      );
    case 'clients.add':
      return '-';
    case 'clients.add_contact':
      return (
        <Link to={'/card/client?id=' + params.client_id} title={t('buttons.Перейти в карточку клиента')}>
          <img src="/images/icon-go.png" alt="" />
        </Link>
      );
    default:
      let out = '-';
      field = params['stay_id'] ? 'stay_id' : params['id'] ? 'id' : '';

      if (field && data.method.indexOf('stays.') !== -1) {
        out = (
          <>
            <Link
              title={t('buttons.Перейти в карточку парковки')}
              to={'/card/stay?id=' + params[field]}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(ev) => {
                ev.stopPropagation();
              }}
            >
              <img src="/images/icon-go.png" alt="" />
            </Link>
          </>
        );
      }

      return out;
  }
};

export const getTableParams = (t) => {
  const fields = [
    {
      name: 'timestamp',
      title: t('grid.Дата и время'),
      width: 210,
      sortField: 'timestamp',
      render: (val) => getDateTime(val),
    },
    {
      name: 'user',
      title: t('inputs.Пользователь'),
      width: 230,
      render: (val) => val?.name,
      // sortField: 'name',
    },
    {
      name: 'role',
      title: t('form.Роль'),
      width: 230,
      render: (_val, _params, row) => row.user?.role,
      // sortField: 'role',
    },
    {
      name: 'action',
      title: t('inputs.Описание'),
      // sortField: 'action',
    },
    {
      name: 'link',
      title: '',
      width: 70,
      render: (_val, _params, row) => getLink(row.data),
      // sortField: 'action',
    },
  ];

  return { fields, withComment: false };
};
